import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';

import {BULK_IMPORT_USERS_STEPS} from './constants';
import {clearUsersBulkImport, selectBulkUserImportStep} from './services/add-attendees-bulk.slice';
import {UploadFileStep} from './steps/upload-file-step/upload-file-step';
import {ValidateFileStep} from './steps/validate-file-step/validate-file-step';

export const AttendeeBulkImport = () => {
    const dispatch = useDispatch();

    const step = useSelector(selectBulkUserImportStep);
    const queryParams = useParams<{accountId: string}>();
    const accountId = queryParams.accountId ? +queryParams.accountId : 0;

    useEffect(() => {
        return () => {
            dispatch(clearUsersBulkImport());
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {step === BULK_IMPORT_USERS_STEPS.UPLOAD_FILE && (
                <UploadFileStep
                    accountId={accountId}
                />
            )}
            {step === BULK_IMPORT_USERS_STEPS.VALIDATE_FILE && (
                <ValidateFileStep/>
            )}
        </>
    );
};
